module.exports = __webpack_public_path__ + "img/3.8aca0e05.jpg";